var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashbordIconDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.747,
    height: 28,
    viewBox: "0 0 15.747 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-dollar-sign",
    "data-name": "Icon awesome-dollar-sign",
    d: "M11.441,12.764,5.535,11.036a1.613,1.613,0,0,1,.454-3.161H9.615a3.338,3.338,0,0,1,1.87.574.853.853,0,0,0,1.066-.109l1.9-1.859a.886.886,0,0,0-.1-1.34A7.733,7.733,0,0,0,9.626,3.5V.875A.878.878,0,0,0,8.751,0H7a.878.878,0,0,0-.875.875V3.5H5.989A5.992,5.992,0,0,0,.028,10.041a6.26,6.26,0,0,0,4.583,5.283l5.605,1.641a1.613,1.613,0,0,1-.454,3.161H6.137a3.338,3.338,0,0,1-1.87-.574A.853.853,0,0,0,3.2,19.66L1.3,21.52a.886.886,0,0,0,.1,1.34A7.733,7.733,0,0,0,6.126,24.5v2.625A.878.878,0,0,0,7,28h1.75a.878.878,0,0,0,.875-.875V24.489a6.177,6.177,0,0,0,5.78-3.976,6.005,6.005,0,0,0-3.965-7.749Z",
    transform: "translate(-0.003)",
    fill: "#f3ba44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashbordIconDollarSign);
export default __webpack_public_path__ + "static/media/dashbord-icon-dollar-sign.ba9c4a3ed9902c4b537649020357d730.svg";
export { ForwardRef as ReactComponent };